import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getOwnedProducts } from 'FormsUI/selectors/Inventory';
import { hasSubscriptionYoungerThan } from 'onboarding-utils/inventoryUtils';
import { useIsStarterPortal } from 'onboarding-scopes';
const useHasTwoMonthOrLessStarterSubscription = () => {
  const isStarterPortal = useIsStarterPortal();
  const ownedProducts = useSelector(getOwnedProducts);
  return useMemo(() => {
    if (!isStarterPortal || !ownedProducts) {
      return false;
    }
    return hasSubscriptionYoungerThan('marketing', 'starter', ownedProducts, 60);
  }, [isStarterPortal, ownedProducts]);
};
export default useHasTwoMonthOrLessStarterSubscription;